import React from 'react';
import Overlay from './Overlay';
import classnames from 'classnames';

const Modal = ({ isOpen, className, children }) => {
  return isOpen ? (
    <Overlay>
      <div
        className={classnames(
          className,
          'shadow-lg bg-white border rounded p-4 max-h-[90vh] overflow-y-auto'
        )}
      >
        {children}
      </div>
    </Overlay>
  ) : null;
};

export default Modal;
